import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    position: fixed;
    right: 0;
    width: 23%;
    height: 100%;
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
`

const Audio = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 50px;
    margin-bottom: 20px;
    border: 1px solid #000;
`

const Video = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 25%;
    border: 1px solid #000;
`

export class Communicator extends React.Component {
    render() {
        return (
            <Container>
                <Audio>آواز</Audio>
                <Video>ویڈیو</Video>
            </Container>
        )
    }
}
